import * as vehicleHelpers from "../helpers/vehicleHelpers"
import * as shopHelpers from "../helpers/shopHelpers"
import { PAID_STATUSES, COMPLETED } from "./statuses"

import moment from "moment"
import { AMERICA, Date_Format } from "./years"
import { isFleetMaintenanceHubCanada } from "../helpers/affiliationHelpers"

export const ACTIVE = "active"
export const PAST = "past"
export const UPCOMING = "upcoming"
export const SCHEDULE_BUTTON_FIELD = "schedule_now"

export const MANUAL_MAINTENANCE_TYPE = "Manual Entry"
export const FLEETADVISE_MAINTENANCE_TYPE = "CarAdvise National Account"

export function activeOrderGridColumnDefs(
  page,
  servicesCellRenderer,
  schedulerCellRenderer,
  statusCellRenderer,
  t
) {
  const widths = {
    xsmall: 125,
    small: 150,
    medium: 175,
    large: 200,
    xlarge: 225,
    xxlarge: 250,
    xxxlarge: 300
  }

  let arr = [
    {
      headerName: t("fleets:fleetLabel"),
      field: "fleet_name",
      width: widths.xlarge,
      filter: true,
      sortable: true
    },
    {
      headerName: "Approval Request Date",
      field: "approval_request_datetime",
      width: widths.small,
      sortable: true,
      valueFormatter: (data) =>
        isFleetMaintenanceHubCanada() && data.value
          ? data.value.format(Date_Format.YYYY_MM_DD)
          : data.value
          ? data.value.format("L")
          : ""
    },
    {
      headerName: "Approval Request Time",
      field: "approval_request_datetime",
      width: widths.xsmall,
      sortable: true,
      valueFormatter: (data) => (data.value ? data.value.format("LT") : "")
    },
    {
      headerName: t("dashboard:vehicleLabel"),
      field: "vehicle",
      width: widths.xlarge
    },
    {
      headerName: "VIN (last 6)",
      field: "vin",
      width: widths.large,
      sortable: false,
      valueFormatter: (data) => data.value?.slice(-6) ?? ""
    },
    {
      headerName: t("dashboard:otherIdLabel"),
      field: "other_id",
      width: widths.small
    },
    {
      headerName: "Dept #",
      field: "department_number",
      width: widths.medium
    },
    {
      headerName: t("shops:shopLabel"),
      field: "shop",
      width: widths.xxlarge,
      resizable: true
    },
    {
      headerName: t("settings:servicesLabel"),
      field: "services",
      width: widths.xxxlarge,
      resizable: true,
      cellRendererFramework: servicesCellRenderer
    },
    {
      headerName: t("vehicle:costLabel"),
      field: "total",
      width: widths.small,
      valueFormatter: (data) =>
        isFleetMaintenanceHubCanada() && data.value
          ? `$${data.value} CAD`
          : data.value
          ? `$${data.value}`
          : ""
    },
    {
      headerName: "Shop Order",
      field: "id",
      width: widths.medium
    }
  ]

  arr.splice(1, 0, {
    headerName: t("statusLabel"),
    field: "status",
    width: widths.small,
    cellRendererFramework: statusCellRenderer,
    minWidth: 100
  })

  return arr
}

export function activeOrderGridRowData(shopOrders, language) {
  return Array.isArray(shopOrders)
    ? shopOrders?.map((order) => {
        const vehicle = order.vehicle
        return {
          appointment_datetime: moment(order.appointment_datetime).startOf("day"),
          vehicle: vehicleHelpers.formattedName(vehicle),
          shop: shopHelpers.formattedName(order.shop, order.custom_shop_name),
          other_id: vehicle.other_id || "N/A",
          department_number: vehicle.department_number || "N/A",
          po_number: order.po_number,
          status: {
            status: PAID_STATUSES.indexOf(order.status) === -1 ? order.status : COMPLETED,
            id: order.id
          },
          time: order.appointment_time_pretty,
          invoice_number: order.invoice_number,
          services: order.order_services
            .filter((os) => os.status !== "rejected" && os.status !== "deleted")
            .map((s) => `${s.name}${s.position ? ` (${s.position})` : ""}`)
            .join(", "),
          total: order.total && parseFloat(order.total).toFixed(2),
          // NOTE: The ID column does not get displayed because there is no mapping for it in the columnDefs, however, providing here makes it available to the row's data attribute.
          id: order.id,
          maintenance_type: order.maintenance_type
            ? MANUAL_MAINTENANCE_TYPE
            : FLEETADVISE_MAINTENANCE_TYPE,
          vin: vehicle.vin,
          vehicle_id: vehicle.id,
          fleet_name: order.fleet_name,
          language,
          fleet_id: order.fleet_id,
          approval_request_datetime: order.approval_request_datetime
            ? order.approval_request_datetime.length === 10
              ? moment(order.approval_request_datetime)
              : moment(order.approval_request_datetime).tz(AMERICA)
            : ""
        }
      })
    : []
}

export const ORDER_STATUSES = {
  initiated: 0,
  initiatedByUser: 1,
  approved: 2,
  saved: 3,
  deleted: 4,
  completed: 5
}
export const YES = "Yes"
export const NO = "No"
